/** @jsx jsx */
import { jsx } from '@emotion/react';
import { daysFromNow } from '@zapier/date';
import { Alert, Link } from '@zapier/design-system';

import type { ResponseData } from '../useAlertBanner/useAlertBannerData';
import { BannerProps } from './types';
import { UserInteractionEvent } from '../../../../universal-nav/utils/avroEvents';

export const shouldRender = (data: ResponseData) => {
  const { isTeamAccount, teamAccountEndDate } = data.currentAccount;
  return (
    !isTeamAccount &&
    !!teamAccountEndDate &&
    daysFromNow(teamAccountEndDate) <= 7
  );
};

export const Component = function TeamsDowngraded(props: BannerProps) {
  const onUpgrade = () => {
    props.trackEvent(UserInteractionEvent, {
      interaction_name: 'teams_downgraded_banner_cta_clicked',
      interaction_goal: 'upgrade_plan',
      event_action: 'click',
      option_selected: 'not_applicable',
    });
  };
  return (
    <Alert
      layout={props.layout}
      title="You’ve recently canceled your Team plan"
      type="info"
    >
      <Link href="/app/checkout/upgrade-to-team" onClick={() => onUpgrade()}>
        Upgrade
      </Link>
      {/* Use `&nbsp;` to prevent text wrapping from making "Upgrade" a widow/orphan */}
      &nbsp;to regain your access to unlimited users, shared app connections,
      premier support, and more
    </Alert>
  );
};
